import { render, staticRenderFns } from "./AppPage.vue?vue&type=template&id=64e5ca6d"
import script from "./AppPage.vue?vue&type=script&lang=js"
export * from "./AppPage.vue?vue&type=script&lang=js"
import style0 from "./AppPage.vue?vue&type=style&index=0&id=64e5ca6d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports